"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/BVFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_36)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_36`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-3.95996 -1.09088H32.0401V25.0909H-3.95996V-1.09088Z",
					fill: "#EF2B2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.85828 -1.09088H12.4037V25.0909H5.85828V-1.09088Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-3.95996 8.72729H32.0401V15.2728H-3.95996V8.72729Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.49463 -1.09088H10.7674V25.0909H7.49463V-1.09088Z",
					fill: "#002868"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-3.95996 10.3637H32.0401V13.6364H-3.95996V10.3637Z",
					fill: "#002868"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_36`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as BVFlag };
